import { ReactElement, useState } from "react";
import { DragDropContext, Draggable, DraggableProvidedDragHandleProps, DropResult, Droppable, ResponderProvided } from "react-beautiful-dnd";

type onChangeWithList<V> = (list: V[]) => void

export interface DndListProps<V> {
    list: V[],
    id: string,
    disabled?: boolean,
    onChange: onChangeWithList<V>
    children: (value: V, index: number, dragProps?: DraggableProvidedDragHandleProps) => ReactElement<HTMLElement>
}


function arraymove(arr:any, fromIndex:any, toIndex:any) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
    //console.log("status after: ");
    //console.log(arr);
}


export default function DndList<V>(props: DndListProps<V>) {
    const [list, setList] = useState(props.list);
    return (
        <DragDropContext key={props.id + "-drop-context"} onDragEnd={(result: DropResult, provided: ResponderProvided) => {
            if(result.destination && result.destination.index != result.source.index) {   
                setList((o) => {
                    let newList = [...o];
                    arraymove(newList, result.source.index, result.destination?.index);
                    props.onChange(newList);
                    return newList
                })
            }
        }}>
            <Droppable droppableId={props.id + "-drop-list"}>
                {(provided, snapshot) => {
                    return (
                        <div key={props.id + "-drop-list-container"} ref={provided.innerRef} style={{
                            backgroundColor:snapshot.isDraggingOver ? 'rgba(190, 190, 190, 0.2)': ''
                        }} {...provided.droppableProps}>
                            {list.map((value: V, index:number ) => {
                                return (
                                    <Draggable isDragDisabled={props.disabled} key={props.id + "-drop-list-draggable-" + index} draggableId={"awards_" + index} index={index}>
                                        {(dragProvided, dragSnap) => {
                                            return (<>
                                                <div ref={dragProvided.innerRef} {...dragProvided.draggableProps}>
                                                    {props.children(value, index, dragProvided.dragHandleProps ?? undefined)}
                                                </div>
                                            </>
                                            )
                                        }}
                                    </Draggable>
                                )
                            })}
                            {provided.placeholder}
                        </div>
                    )
                }}
            </Droppable >
        </DragDropContext>
    )
}